import Box from 'carbon-react/esm/components/box';
import Loader from 'carbon-react/lib/components/loader/__next__';

const PageLoadingComponent = () => {
  return (
    // <Box height="700px" display="flex" alignItems="center" justifyContent="center">
    //   <LoaderSpinner showSpinnerLabel={false} />
    // </Box>
    <Box
      height="700px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Loader mx="3" loaderType="ring" />
    </Box>
  );
};

export default PageLoadingComponent;
